import { render, staticRenderFns } from "./Breadcumb.vue?vue&type=template&id=68d816e2&scoped=true&"
import script from "./Breadcumb.vue?vue&type=script&lang=js&"
export * from "./Breadcumb.vue?vue&type=script&lang=js&"
import style0 from "./Breadcumb.vue?vue&type=style&index=0&id=68d816e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d816e2",
  null
  
)

export default component.exports